import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WKContextMenuComponent } from './wk-context-menu-editor';
import { CKEditorModule } from '../../../ckeditor/ckeditor.module';

function components() {
  return [WKContextMenuComponent];
}

@NgModule({
  imports: [CommonModule, CKEditorModule],
  declarations: components(),
  exports: components(),
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EditorSharedModule {}
